import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CrossComponentService } from '../../../core/services/cross-component.service';
import { CallModal } from "../../../shared/call-modal/call-modal";

@Component({
  selector: 'app-carousel',
  imports: [RouterLink, CallModal],
  templateUrl: './carousel.html',
  styleUrl: './carousel.scss',
})
export class Carousel {
  private instance: any;
  private retryTimeoutId?: number;
  private destroyed = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public crossComponentService: CrossComponentService
  ) { }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.initCarousel(10);
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
    if (this.retryTimeoutId !== undefined) {
      clearTimeout(this.retryTimeoutId);
      this.retryTimeoutId = undefined;
    }
    if (this.instance) {
      if (this.instance.touchTimeout) {
        clearTimeout(this.instance.touchTimeout);
        this.instance.touchTimeout = null;
      }
      this.instance.pause?.();
      this.instance.dispose?.();
    }
  }

  private initCarousel(retries: number) {
    const carouselEl = document.getElementById('carouselExample');
    const CarouselCtor = (window as any)?.bootstrap?.Carousel;

    if (!carouselEl || !CarouselCtor) {
      if (retries > 0) {
        this.retryTimeoutId = window.setTimeout(() => {
          if (!this.destroyed) {
            this.initCarousel(retries - 1);
          }
        }, 50);
      }
      return;
    }

    this.instance = CarouselCtor.getOrCreateInstance(carouselEl, {
      interval: 4000,
      ride: 'carousel'
    });
    this.instance.cycle();
  }
}
